'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useLanguage } from '../../../../../context/LanguageContext';
import { formatEmiratesId } from '../../../../../utils/validationUtils';

export default function BuyerStep4PersonalDetails() {
  const { register, formState: { errors, touchedFields, isSubmitted }, setValue } = useFormContext();
  const { translate } = useLanguage();

  const handleEmiratesIdChange = (e) => {
    const formatted = formatEmiratesId(e.target.value);
    setValue('emiratesIdNumber', formatted, { shouldValidate: true });
  };

  return (
    <div className="space-y-6">
      <div className='text-center'>
        <h2 className="text-2xl font-bold text-white mb-2">
          {translate("auth.signup.personalDetails")}
        </h2>
        <p className="text-white">
          {translate("auth.signup.providePersonalInfo")}
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="location" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.location")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('location')}
            id="location"
            type="text"
            placeholder={translate("auth.signup.locationPlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.location || isSubmitted) && errors.location && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.location.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="emiratesIdNumber" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.emiratesIdNumber")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('emiratesIdNumber')}
            id="emiratesIdNumber"
            type="text"
            placeholder={translate("auth.signup.identificationNumberPlaceholder")}
            maxLength={18}
            onChange={handleEmiratesIdChange}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.emiratesIdNumber || isSubmitted) && errors.emiratesIdNumber && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.emiratesIdNumber.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="eidExpiryDate" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.eidExpiryDate")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('eidExpiryDate')}
            id="eidExpiryDate"
            type="date"
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all
      [&::-webkit-calendar-picker-indicator]:invert [&::-webkit-calendar-picker-indicator]:brightness-0 [&::-webkit-calendar-picker-indicator]:invert-[1] [&::-webkit-calendar-picker-indicator]:filter"
          />
          {(touchedFields.eidExpiryDate || isSubmitted) && errors.eidExpiryDate && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.eidExpiryDate.message)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
